import { parsePhoneNumberFromString } from 'libphonenumber-js';

export default (value: string): boolean => {
  const phoneNumber = parsePhoneNumberFromString(value);

  return phoneNumber !== undefined && phoneNumber.isValid() && phoneNumber.isPossible();
};
